import styled, { css } from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";
import Menu, { MenuItemProps as AntMenuItemProps } from "antd/es/menu";
import { green, orange } from "@ant-design/colors";

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface MenuItemProps extends AntMenuItemProps {
  $success?: boolean;
  $warning?: boolean;
  $invalid?: boolean;
  danger?: boolean;
}

const MenuItem = styled(Menu.Item)<MenuItemProps>`
  color: ${(p) => p.theme.colors.textColor};
  &:hover {
    background: ${(p) => p.theme.colors.hoverBgColor};
  }
  ${({ $success }) =>
    $success &&
    `
    color: ${green[6]};
    &:hover {
      color: white;
      background: ${green[6]};
    }
  `}

  ${(props) =>
    props.$warning &&
    `
    color: ${orange[5]};
    &:hover {
      color: white;
      background: ${orange[5]};
    }
  `}
  ${(props) =>
    props.$invalid &&
    `
    opacity: 0.3;
  `}
`;

const FiltersWrapper = styled.div<{ $addTopBorder?: boolean }>`
  padding: 8px;
  border-bottom: ${(p) => p.theme.borders.light};

  ${(p) =>
    p.$addTopBorder &&
    `
    border-top: ${p.theme.borders.light};
  `};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      padding: 8px 16px;
      border-bottom: 1px solid ${getNewLookTokens(p.theme).hairline};
    `}
`;

export { StatusWrapper, MenuItem, FiltersWrapper };
